import clsx from "clsx";
import { useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";

import Button from "~/components/common/button";
import Loader from "~/components/common/loader";
import {
  getBasketWeightKg,
  isTarifDisabledByWeight,
  parseWeightLimitTkList,
} from "~/components/pages/personal/cartNew/deliveryTkConfig";
import { showPopup } from "~/redux/action-creaters/popup";
import { popupTypes } from "~/redux/reducers/popupReducer";

import styles from "../../deliveryNew/index.module.scss";

/**
 * Таблица тарифов еДОСТ. Данные — из новой модели корзины
 * (state.cart.edostData.companies), фильтр по весу — общий хелпер корзины.
 */
export default function Edost({ delivery, onBuy, canBuy, isShow }: any) {
  const dispatch = useDispatch();
  const { edostData, isEdostDataLoading, basket } = useSelector(
    (state: any) => state.cart,
  );

  const basketWeightKg = useMemo(() => getBasketWeightKg(basket), [basket]);
  const weightLimitByTk = useMemo(
    () => parseWeightLimitTkList(delivery?.CONFIG?.WEIGHT_LIMIT_TK_LIST),
    [delivery?.CONFIG?.WEIGHT_LIMIT_TK_LIST],
  );

  const companies = useMemo(() => {
    const list = Array.isArray(edostData?.companies) ? edostData.companies : [];
    return list
      .filter(
        (company: any) =>
          !isTarifDisabledByWeight(
            String(company.company ?? ""),
            basketWeightKg,
            weightLimitByTk,
          ),
      )
      .map((company: any) => ({
        ...company,
        priceNumber: Math.max(0, parseInt(company.price, 10) || 0),
      }))
      .sort((a: any, b: any) => a.priceNumber - b.priceNumber);
  }, [edostData?.companies, basketWeightKg, weightLimitByTk]);

  if (!isShow) {
    return null;
  }

  if (isEdostDataLoading) {
    return (
      <div className={styles.Loader}>
        <Loader />
      </div>
    );
  }

  if (companies.length === 0) {
    return (
      <div>
        <p>
          Не удалось рассчитать доставку в ваш город. Выберите другой город или
          уточните у менеджера способы доставки:
        </p>
        <div>
          <Button
            customStyles={styles.FormButton}
            onClick={() => dispatch(showPopup(popupTypes.backCall))}
            label="Уточнить способы доставки"
          />
        </div>
      </div>
    );
  }

  return (
    <div className={clsx(styles.TableMiddle, styles.Table)}>
      <span className={styles.Head}>Название компании</span>
      <span className={styles.Head}>Сроки доставки</span>
      <span className={styles.Head}>Стоимость</span>
      <span className={styles.HeadLast} />
      {companies.map((company: any) => (
        // eslint-disable-next-line react/jsx-key
        <>
          <span>{company.company}</span>
          <span>{company.days}</span>
          <span>
            {company.priceNumber > 0 ? (
              <div>{company.priceNumber} руб</div>
            ) : (
              <div>бесплатно</div>
            )}
          </span>
          <span className={styles.TableButton}>
            {canBuy && (
              <Button label="Оформить покупку" type="outline" onClick={onBuy} />
            )}
          </span>
        </>
      ))}
    </div>
  );
}
